import type { UITranslations } from './types';

export const vi: UITranslations = {
    common: {
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        delete: 'Xóa',
        confirmDelete: 'Bạn có chắc chắn muốn xóa mục này không?',
        view: 'Xem',
        edit: 'Sửa',
        duplicate: 'Nhân bản',
        refresh: 'Làm mới',
        noData: 'Không có dữ liệu',
        actions: 'Thao tác',
        showing: '{{from}}-{{to}} trong tổng số {{total}}',
        filters: 'Bộ lọc',
        resetFilters: 'Đặt lại bộ lọc',
        noFiltersAvailable: 'Không có bộ lọc nào',
        resetToDefault: 'Đặt lại mặc định',
        showColumns: 'Cột hiển thị',
        search: 'Tìm kiếm',
        changeFile: 'Đổi tệp',
        removeFile: 'Xóa tệp',
        noPermissionTooltip: 'Bạn không có quyền thực hiện thao tác này',
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        all: 'Tất cả',
        startDate: 'Từ ngày',
        endDate: 'Đến ngày',
        columns: 'Cột',
        retry: 'Thử lại',
        errorTitle: 'Đã xảy ra lỗi',
    },
    upload: {
        fileTooLarge: 'Tệp quá lớn',
        invalidFormat: 'Định dạng tệp không được hỗ trợ',
        uploadError: 'Tải lên thất bại',
        uploaded: 'Tải lên thành công',
        uploading: 'Đang tải lên...',
        uploadHint: 'Nhấp hoặc kéo tệp vào khu vực này để tải lên',
        stagingHint: 'Nhấn để chọn tệp tham khảo',
        uploadFormats: 'Chỉ hỗ trợ các định dạng cho phép',
        previewAlt: 'Xem trước',
        changeImage: 'Đổi ảnh',
        remove: 'Xóa',
    },
    password: {
        weak: 'Yếu',
        medium: 'Trung bình',
        strong: 'Mạnh',
    },
    pageHeader: {
        aboutThisPage: 'Giới thiệu về trang này',
    },
    collapsible: {
        expand: 'Mở rộng',
        collapse: 'Thu gọn',
    },
};
